import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    width: 350,
    alignSelf: 'center',
  },
  legendText: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 5,
    marginBottom: 5,
    fontSize: 18,
    color: '#89909B',
    opacity: 0.8,
  },
  btnContainer: {
    alignSelf: 'center',
    width: 350,
  },
  btn: {
    marginTop: 16,
    marginBottom: 20,
    width: 350,
    height: 50,
    borderRadius: 12,
  },
  disabledBtn: {
    backgroundColor: '#89909b',
  },
  btnText: {
    color: '#FFF',
    fontSize: 18,
  },
  phoneInputContainer: {
    marginHorizontal: 16,
  },
  loginFormContainer: {
    marginTop: 16,
  },
  textInputContainer: {
    marginBottom: 16,
  },
  textInput: {
    fontSize: 14,
    color: '#3f3a40',
    textAlign: 'left',
    borderColor: '#c9c9c9',
    backgroundColor: 'white',
    borderRadius: 12,
    height: 45,
    width: 350,
    paddingHorizontal: 16,
    borderWidth: 1,
  },
  errorTextContainer: {
    padding: 8,
    borderColor: '#f5c6cb',
    backgroundColor: '#f8d7da',
    borderWidth: 1,
    borderRadius: 8,
    marginTop: 4,
  },
  errorText: {
    color: '#EC1C24',
    fontSize: 16,
  },
  loginErrorTextContainer: {
    marginBottom: 8,
    borderWidth: 1,
    borderColor: '#f5c6cb',
    borderRadius: 8,
    padding: 8,
    backgroundColor: '#f8d7da',
  },
  loginErrorText: {
    color: '#EC1C24',
    fontSize: 16,
  },
});
